import React, { Component } from 'react';
import ModalHeader from 'components/base/secure/modals/modal-header';
import DeleteButton from "components/form/delete-button";
import PropTypes from "prop-types";
import ModalContent from "components/base/secure/modals/modal-content";
import { Trans, withNamespaces } from 'react-i18next';
import CancelButton from 'components/form/cancel-button';

@withNamespaces()
class DeleteItemModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: false,
        };

        this.dismiss = this.dismiss.bind(this);
        this.submit = this.submit.bind(this);
        this.closeOutside = this.closeOutside.bind(this);
        this.deleteWithTransactions = this.deleteWithTransactions.bind(this);
    }

    deleteWithTransactions(e) {
        this.submit(e, true);
    }

    submit(e, includeTransactions) {
        e.preventDefault();

        if (!this.state.loading) {
            this.setState({loading: true});

            this.props.smallCategoryRef.requestDelete(includeTransactions)
                .then(response => {
                    // Object will memory leak if it tries calling onDismiss because it will no longer exist
                    if (includeTransactions || this.props.smallCategoryRef.actual === 0) {
                        return;
                    }

                    this.props.onDismiss();
                })
                .catch(err => {
                    this.setState({loading: false});
                });
        }
    }

    dismiss() {
        if (!this.state.loading) {
            this.props.onDismiss()
        }
    }

    closeOutside() {
        this.dismiss();
    }

    render() {
        const { t, smallCategoryRef } = this.props;
        const { name } = smallCategoryRef;
        const { loading } = this.state;

        return (
            <ModalContent closeOutside={this.closeOutside}>
                <ModalHeader
                    title={t('BUDGET.BUDGET_ITEM.DELETE_TITLE')}
                    close={this.dismiss}
                />
                <div className="modal-body">
                    <form onSubmit={this.submit}>
                        <div style={{fontSize: '16px'}}>
                            <Trans i18nKey="BUDGET.BUDGET_ITEM.DELETE_TEXT">
                                <span style={{fontWeight: '700'}}>{{categoryName: name}}</span>
                            </Trans>
                        </div>
                        <div className="modal-footer modal-footer-space">
                            <DeleteButton loading={loading} text="BUDGET.BUDGET_ITEM.DELETE_ITEM_BUTTON" />
                            <DeleteButton loading={loading} onClick={this.deleteWithTransactions} text="BUDGET.BUDGET_ITEM.DELETE_ALL_BUTTON" />
                            <CancelButton loading={loading} onClick={this.dismiss} />
                        </div>
                    </form>
                </div>
            </ModalContent>
        );
    }
}

DeleteItemModal.propTypes = {
    /** A function that will be called when the modal will be successfully submitted */
    onSuccess: PropTypes.func.isRequired,

    /** A function that will be called when the modal is dismissed (like when user clicks outside) */
    onDismiss: PropTypes.func.isRequired,

    /** Small category object */
    smallCategoryRef: PropTypes.object.isRequired,
};

export default DeleteItemModal;


// WEBPACK FOOTER //
// ./src/modules/budget/components/budget-modals/delete-item-modal.js